import {
	CMD_SHIFT_CLICK_ANALYTICS_ID,
	SHIFT_CLICK_ANALYTICS_ID,
	CHECKBOX_ANALYTICS_ID,
	CMD_CLICK_ANALYTICS_ID,
} from './constants';
import type { CardSelectionAnalyticsInputTypes } from './types';

export const getCardSelectionAnalyticsInputSource = (
	withShift: boolean,
	withCmd: boolean,
	viaCheckbox: boolean,
): CardSelectionAnalyticsInputTypes => {
	if (withShift && withCmd) {
		return CMD_SHIFT_CLICK_ANALYTICS_ID;
	}
	if (withShift) {
		return SHIFT_CLICK_ANALYTICS_ID;
	}
	if (viaCheckbox) {
		return CHECKBOX_ANALYTICS_ID;
	}
	return CMD_CLICK_ANALYTICS_ID;
};
